import baseTariffication from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:baseTariffication,
      name:'baseTariffication'
    },
  ]
};
